export default __webpack_public_path__ + "static/media/category_09.21eb8f5b.png";